import {
  SET_FILTER_DROPDOWN_SHOW,
  SET_FILTER_VALUE,
  SET_FORM_CONTROL_SHOW,
  RESET_FILTER,
} from '../actions/types';

const initialState = {
  filterDropdownShow: false,
  filterValue: [],
  formControlShow: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_FILTER_DROPDOWN_SHOW:
      return {
        ...state,
        filterDropdownShow: action.show,
      };
    case SET_FILTER_VALUE:
      return {
        ...state,
        filterValue: action.filterValue,
      };
    case SET_FORM_CONTROL_SHOW:
      return {
        ...state,
        filterDropdownShow: false,
        formControlShow: action.show,
        filterValue: action.filterValue || state.filterValue,
      };
    case RESET_FILTER:
      return initialState;
    default:
      return state;
  }
}
